export class CorrectEmailCode{
  email:string = "";
  code?:number;
}
